import { List, ListItem } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon";
import Tooltip from "@material-ui/core/Tooltip";
import CheckCircleTwoTone from "@material-ui/icons/CheckCircleTwoTone";
import ErrorTwoTone from "@material-ui/icons/ErrorTwoTone";
import React from "react";
import {
  EnumUpdatePriceProductStatus,
  MUpdatePriceProduct
} from "../../../../../../../server/routes/logUpdated/price/types";
import { ColumnStatusFC } from "./types";

const statusData: {
  [key in EnumUpdatePriceProductStatus]: {
    Icon: React.VFC<SvgIconProps>;
    createTitle: (
      item: MUpdatePriceProduct
    ) => NonNullable<React.ReactNode>;
    color: SvgIconProps["color"];
  };
} = {
  [EnumUpdatePriceProductStatus.SUCCESS]: {
    Icon: CheckCircleTwoTone,
    color: "success",
    createTitle: () => "Успешно",
  },
  [EnumUpdatePriceProductStatus.FAILED]: {
    Icon: ErrorTwoTone,
    color: "error",
    createTitle: ({ errors = [] }) =>
      errors.filter((error) => error.length > 0).length > 0 ? (
        <>
          <List disablePadding subheader={"Есть ошибки"}>
            {errors
              .filter((error) => error.length > 0)
              .map((error) => (
                <ListItem key={error} disablePadding>
                  {" - "}
                  {error}
                </ListItem>
              ))}
          </List>
        </>
      ) : (
        "Есть ошибки"
      ),
  },
};

const ColumnStatus: ColumnStatusFC = ({ item }) => {
  const { Icon, createTitle, color } = statusData[item.status];
  return (
    <Tooltip
      title={createTitle(item)}
      sx={{
        "& .MuiTooltip-tooltip": {
          whiteSpace: "pre-wrap",
          wordWrap: "break-word",
        },
      }}
    >
      <Icon color={color} />
    </Tooltip>
  );
};

export default ColumnStatus;
